import { useContext, useEffect, useState } from "react";
import { ToolContext } from "../../../../../../core/context/ToolContext";
import { JoyrideWrapper } from "../../JoyrideWrapper";

export const PropertyInquiries = ({ end }) => {
	
	const {personalization_state} = useContext(ToolContext)
	const {walkthrough, startHere} = personalization_state
	const [firstStepReady, setFirstStepReady] = useState(false);

	const endTour = ()=>{
		walkthrough.set((p) => ({ ...p, propertyInquiries: false}))
		startHere.set((p) => ({ ...p, show: true}))
		setFirstStepReady(false);
	}

	const steps = [
		{
			target: '.propertyInquiriesFirstStep',
			title: "View Property",
			content: 'Click to see the inquired property.',
			disableBeacon: true,
			placement: "left",
		},
		{
			target: '.propertyInquiriesSecondStep',
			title: "Modify Property Inquiry",
			content: 'Click to update this property inquiry status.',
			disableBeacon: true,
			placement: "left",
		},
		{
			target: '.propertyInquiriesThirdStep',
			title: "Enable or Disable Property",
			content: 'Click to enabled or disabled this property.',
			disableBeacon: true,
			placement: "left",
		},
		{
			target: '.propertyInquiriesFourthStep',
			title: "Inquiry Category",
			content: 'This section shows the details of the current inquiry as categorized.',
			disableBeacon: true,
			placement: "bottom",
			modalTriggers: 'propertyInquiries',
		},
		{
			target: '.propertyInquiriesFifthStep',
			title: "Client Details",
			content: 'This is where you can know who is making an inquiry.',
			disableBeacon: true,
			placement: "bottom"
		},
		{
			target: '.propertyInquiriesSixthStep',
			title: "Update Inquiry",
			content: "Click to update this inquiry of property.",
			disableBeacon: true,
			placement: "top"
		},
	]

	useEffect(() => {
		const interval = setInterval(() => {
			const el = document.querySelector('.propertyInquiriesFirstStep');
			if (el) {
				clearInterval(interval);
				setFirstStepReady(true);
			}
		}, 100);
		return () => clearInterval(interval);
	}, []);

	return (
		firstStepReady &&
		<JoyrideWrapper 
			run={Boolean(walkthrough.data.propertyInquiries)} 
			steps={steps} 
			setter={endTour} 
			end={end}
			p_name="propertyInquiries" 
			featureName="sales"
		/>
	);
}
